"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_image_1 = require("@hotelplan/components.common.image");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const HeroWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    variant: 'hero.wrap',
    position: 'relative',
    color: 'white',
    bg: 'darkGray',
}));
const HeroImage = (0, styled_components_1.default)(components_common_image_1.Image)(({ isFullWidth, mainImagePercentageWidth }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    objectFit: 'cover',
    width: isFullWidth
        ? '100%'
        : mainImagePercentageWidth
            ? [`${mainImagePercentageWidth[0]}%`, `${mainImagePercentageWidth[1]}%`]
            : ['67%', '60%'],
    height: '100%',
}));
const MacroImage = (0, styled_components_1.default)(components_common_image_1.Image)(({ mainImagePercentageWidth }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    objectFit: 'cover',
    width: mainImagePercentageWidth
        ? [
            `${100 - mainImagePercentageWidth[0]}%`,
            `${100 - mainImagePercentageWidth[1]}%`,
        ]
        : ['33%', '40%'],
    height: '100%',
}));
const HeroImageSkeleton = styled_components_1.default.div(({ theme: { colors } }) => ({
    backgroundColor: colors.lightGreySecond,
    width: '100%',
    height: '100%',
}));
const HeroContent = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    top: 0,
    left: 0,
    position: 'absolute',
    width: '100%',
    px: 4,
    py: 5,
}));
const HeroTitle = styled_components_1.default.h2((0, util_theme_sxc_1.sx2CssThemeFn)({
    textAlign: 'center',
    fontSize: [5, 6],
}));
const imageDefaults = {
    lazy: false,
    decoding: `sync`,
    loading: `eager`,
};
const Hero = props => {
    const { title, children, image, macroImage, mainImagePercentageWidth, className, } = props;
    return (react_1.default.createElement(HeroWrapper, { className: className },
        image && react_1.default.createElement(components_common_image_1.PreloadImage, Object.assign({}, image, { id: "hero" })),
        image ? (react_1.default.createElement(react_1.default.Fragment, null,
            macroImage ? (react_1.default.createElement(MacroImage, Object.assign({}, macroImage, imageDefaults, { mainImagePercentageWidth: mainImagePercentageWidth }))) : null,
            react_1.default.createElement(HeroImage, Object.assign({}, image, imageDefaults, { isFullWidth: !macroImage, mainImagePercentageWidth: mainImagePercentageWidth })))) : (react_1.default.createElement(HeroImageSkeleton, null)),
        react_1.default.createElement(HeroContent, { className: "hero-content" },
            title && react_1.default.createElement(HeroTitle, null, title),
            children && react_1.default.createElement(react_1.default.Fragment, null, children))));
};
exports.default = Hero;
//# sourceMappingURL=Hero.js.map